module.exports = __webpack_public_path__ + "dcd51ef8adefa9c72b545daad8a5518c.png";